<template>
  <v-content class="main-content">
    <transition name="fade-transform" mode="out-in">
      <keep-alive>
        <slot>
          <router-view />
        </slot>
      </keep-alive>
    </transition>
  </v-content>
</template>

<script>
export default {
  name: "AppContent",
  data: () => ({})
};
</script>

<style lang="scss" scoped>
  .main-content {
    background: $bh-blue--4;
  }
</style>
